import { useState } from 'react'
import { useMasonry } from '../../hooks/useMasonry'
import { GalleryItem } from './GalleryItem'
import type { Image } from '../../types/image'

interface MasonryGroupProps {
  images: Image[]
  onImageClick: (index: number) => void
  getIndex: (image: Image) => number
  selectedIds?: Set<string>
  onToggleSelect?: (imageId: string) => void
  selectionMode?: boolean
}

export const MasonryGroup: React.FC<MasonryGroupProps> = ({
  images,
  onImageClick,
  getIndex,
  selectedIds,
  onToggleSelect,
  selectionMode = false,
}) => {
  const [containerEl, setContainerEl] = useState<HTMLDivElement | null>(null)
  const { columns, colCount } = useMasonry(images, containerEl)

  if (images.length === 0) return null

  return (
    <div
      ref={setContainerEl}
      className="grid gap-4"
      style={{ gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` }}
    >
      {columns.map((col, colIdx) => (
        <div key={colIdx} className="flex flex-col gap-4">
          {col.map((img) => (
            <GalleryItem
              key={img.imageId}
              image={img}
              aspectRatio={img.width && img.height ? img.width / img.height : undefined}
              onClick={() => onImageClick(getIndex(img))}
              isSelected={selectedIds?.has(img.imageId)}
              onToggleSelect={onToggleSelect ? () => onToggleSelect(img.imageId) : undefined}
              selectionMode={selectionMode}
            />
          ))}
        </div>
      ))}
    </div>
  )
}
